export default __webpack_public_path__ + "static/media/minus.7932b80b.svg";